import { render, staticRenderFns } from "./UserManagerViewInfoCard.vue?vue&type=template&id=67342fdd&scoped=true&"
import script from "./UserManagerViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserManagerViewInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserManagerViewInfoCard.vue?vue&type=style&index=0&id=67342fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67342fdd",
  null
  
)

export default component.exports